import React from 'react';
import { CenterText } from './centerText/centerText';
import { Chart as ChartJS, ArcElement } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import 'chart.js/auto';
ChartJS.register(ArcElement);
const Chart = ({ title: { title, amount }, width = '18.75rem', height = '18.75rem', items }) => {
    ChartJS.register(ArcElement);
    const labels = items.map(item => item.title);
    const values = items.map(item => {
        if (!isNaN(Number(item.value))) {
            return item.value;
        }
    });
    const colors = items.map(item => item.color);
    const data = {
        labels: labels,
        datasets: [
            {
                data: values,
                backgroundColor: colors,
                borderWidth: 0,
                weight: 0.2
            }
        ]
    };
    const options = {
        cutout: '60%',
        plugins: {
            datalabels: {
                display: false
            },
            title: {
                display: false
            },
            legend: {
                display: false
            },
            tooltip: {
                enabled: false
            }
        }
    };
    return (React.createElement("div", { style: { width: width, height: height, position: 'relative', display: 'flex', alignItems: 'center' } },
        React.createElement(Doughnut, { data: data, options: options }),
        React.createElement("div", { style: {
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                textAlign: 'center',
                lineHeight: '20px',
                backgroundColor: 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement(CenterText, { title: title, amount: amount }))));
};
export default Chart;
